import React from 'react';

function Profile() {
  return <div>Página de perfil</div>;
}

export default Profile;
